import styled from 'styled-components';

export const StyledError = styled.div`
  font-size: 11px;
  color: red;
  margin-bottom: 10px;
`;
